/* eslint-disable @typescript-eslint/no-non-null-assertion */
import '@fontsource/poppins'
import { LicenseManager } from 'ag-grid-enterprise'
import { createRoot } from 'react-dom/client'
import './ag-theme-deepcell.css'
import App from './components/App'
import { AG_GRID_LICENSE_KEY } from './config'
import initializeDatadog from './services/initialization'
import './index.css'

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY)

// Initialize cloud services
initializeDatadog()

// https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html
const container = document.getElementById('root')!
const root = createRoot(container)
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//
// Disabled due to adding in Mock Service Worker:
// https://mswjs.io/docs/getting-started/integrate/browser#create-react-app-version-3
//
// If we need the app to work offline later, review how to use this
// serviceWorker.unregister()
